import React from 'react';

import { createRoot } from 'react-dom/client';

import Logger from '../../services/Logger';
import HowDoYouWantToEditTextDialog from './HowDoYouWantToEditTextDialog';
import { EDIT_DRAFT_TEXT_CANCEL } from './editDraftTextStrategy';

export default function showHowDoYouWantToEditTextDialog({
  hasLive = false,
  hasDraftText = false,
} = {}) {
  Logger.log('UI', 'ShowHowDoYouWantToEditTextDialog');

  return new Promise((resolve) => {
    const dialogRoot = document.getElementById('dialogRoot');
    const wrapperDialog = document.createElement('div');
    wrapperDialog.id = 'wrapperHowDoYouWantToEditTextDialog';
    wrapperDialog.className = 'wrapperDialogOverlay';
    dialogRoot.appendChild(wrapperDialog);

    const root = createRoot(wrapperDialog);

    const cleanup = (action) => {
      Logger.log('User', 'HowDoYouWantToEditTextDialogClosed', { action });
      try {
        root.unmount();
      } catch { /* ignore */ }
      if (wrapperDialog.parentNode) {
        dialogRoot.removeChild(wrapperDialog);
      }
      resolve(action);
    };

    root.render(
      <HowDoYouWantToEditTextDialog
        hasLive={hasLive}
        hasDraftText={hasDraftText}
        onProceed={(action) => cleanup(action)}
        onCancel={() => cleanup(EDIT_DRAFT_TEXT_CANCEL)}
      />,
    );
  });
}
